import { Button, ButtonBaseProps } from '@shared/components/Button';
import { grid } from '@shared/styles';

type MenuGearButtonProps = Pick<ButtonBaseProps, 'onClick' | 'testID' | 'className'> & {
  /** What the gear opens, as its accessible name — e.g. "Manage tags". */
  label: string;
};

/**
 * Menu.GearButton
 *
 * Ghost, icon-only gear for a menu's settings or manage step. Render it in a
 * `Menu.TitleBar`'s `endContent`, next to `Menu.CloseButton`. Unlike the back
 * and close buttons it has no default action, so `onClick` and `label` say
 * what it opens.
 */

export function MenuGearButton({
  label,
  onClick,
  testID = 'menu-gear-button',
  className,
}: MenuGearButtonProps) {
  return (
    <Button
      icon="gear"
      iconSize={grid(4)}
      iconOnly
      variant="ghost"
      size="medium"
      label={label}
      onClick={onClick}
      testID={testID}
      className={className}
    />
  );
}
